export default __webpack_public_path__ + "static/media/rocket_anim_63.a5ce287f.png";